import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import { showLoader } from '@app/javascript/classes/loaderExtensions'
import { handleQuantityButtonKeydown, handleQuantityButtonKeyup } from '@app/javascript/classes/clickEvents'

export default class extends Controller {
  static targets = ['form', 'submitButton']

  connect() {
    useDispatch(this)
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('filters-container:filterCleared', this.triggerFilter.bind(this), {})
    }
  }

  triggerFilter() {
    showLoader('#files-loader')
    this.submitButtonTarget.click()
    const searchParams = $(this.formTarget).serialize()
    this.dispatch('formTriggered', {
      params: searchParams,
      filters_applied: $.deparam($(this.formTarget).serialize())
    })
    this.dispatch('syncUrl', {
      searchParams: searchParams
    })
  }

  uncheckAll() {
    this.fileSelectController().uncheckAll()
  }

  fileSelectController() {
    return this.application.getControllerForElementAndIdentifier(this.fileSelectControllerElement(), 'entity-select')
  }

  fileSelectControllerElement() {
    return document.querySelector('#entity-select')
  }

  /**
   * The Actions "quantity" buttons are coded as radio inputs with the button role bolted on,
   * so that assistive technology will recognize them as toggle buttons.
   * In order to make these radio buttons behave like toggle buttons, too,
   * we need to adjust how they behave to certain keystrokes.
   * @param {KeyboardEvent} event
   */
  handleQuantityButtonKeydown(event) {
    handleQuantityButtonKeydown(event)
  }

  /**
   * When the user tabs on to the first quantity selection button,
   * prevent the default event.
   * @param {KeyboardEvent} event
   */
  handleQuantityButtonKeyup(event) {
    handleQuantityButtonKeyup(event)
  }
}
